import { useQuery } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';
import { cleanObjectEmptyFields } from '@hero/utils';

function useGetRecognitionRecipientList(params, options) {
  const {
    code,
    filters: { emails, searchTerm } = {},
    pagination: { limit = 10, page = 1 } = {},
    options: { pagination = true, exists, select = '' } = {}
  } = params;

  return useQuery(
    ['recognition-recipients', code, searchTerm, page, limit, emails, select, exists],
    () => {
      return recognitionServices.recogRecipientsList(
        code,
        cleanObjectEmptyFields({
          filters: {
            emails,
            searchTerm
          },
          pagination: {
            limit,
            page
          },
          options: {
            select,
            pagination,
            exists
          }
        })
      );
    },
    options
  );
}

export { useGetRecognitionRecipientList };
